import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { Col, Row, Card, CardBody } from "reactstrap";
import TableContainer from "../../Components/Common/TableContainer";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import DeleteModal from "Components/Common/DeleteModal";
import { toast, ToastContainer } from "react-toastify";
import { approveTutor, deleteUser, getMentors } from "utils/apiService";
import TeamsModal from "./TeamsModal";
import { RejectModal } from "Components/Common/RejectModal";

const TeamsList = () => {
  document.title = "Expert Team";

  const [teams, setTeams] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [rejectMentor, setRejectMentor] = useState<any>(null);
  const [rejectReason, setRejectReason] = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    fetchTeam();
  }, []);

  const fetchTeam = async () => {
    try {
      const data = await getMentors();
      setTeams(data.response);
    } catch (err) {
      console.error("Failed to fetch students:", err);
    }
  };

  const confirmDelete = async () => {
    console.log("Deleted successfully!");
    try {
      if (selectedMentor) {
        await deleteUser((selectedMentor as { user_id: number }).user_id);
        toast.success("Mentor deleted successfully!");
        fetchTeam();
      }
    } catch (error) {
      toast.error("Failed to delete mentor.");
      console.error("Delete Error:", error);
    } finally {
      setDeleteModal(false);
      setSelectedMentor(null);
    }
  };
  const handleDelete = (mentor: any) => {
    setDeleteModal(true);
    setSelectedMentor(mentor);
  };

  const handleApprove = async (mentor: any) => {
    const result = await approveTutor({
      approve: true,
      id: mentor.user_id,
    });
    console.log(mentor.user_id);
    if (result.success) {
      toast.success("Tutor Approved!");
      fetchTeam();
    }
  };
  const handleReject = (mentor: any) => {
    setRejectMentor(mentor);
    setRejectModal(true);
  };

  const confirmReject = async () => {
    try {
      if (rejectMentor) {
        const result = await approveTutor({
          approve: false,
          id: rejectMentor.user_id,
          reason: rejectReason,
        });

        if (result.success) {
          toast.error("Tutor Rejected!", {
            icon: (
              <i className="mdi mdi-close-circle font-size-24 text-danger" />
            ),
          });
          fetchTeam();
        }
      }
    } catch (error) {
      toast.error("Failed to reject tutor.");
      console.error("Reject Error:", error);
    } finally {
      setRejectModal(false);
      setRejectMentor(null);
      setRejectReason("");
    }
  };
  const handleWhatsApp = (phoneNumber: string) => {
    if (phoneNumber) {
      const formattedNumber = phoneNumber.replace(/\D/g, "");
      window.open(`https://wa.me/${formattedNumber}`, "_blank");
    } else {
      alert("Phone number not available");
    }
  };
  const handleEdit = (mentor: any) => {
    setSelectedMentor(mentor);
    setModalOpen(true);
  };
  const handleAdd = () => {
    setSelectedMentor(null);
    setModalOpen(true);
  };

  const columns = useMemo(
    () => [
      {
        header: "Sr No.",
        cell: (cellProps) => {
          // Adding 1 because array index starts from 0
          return cellProps.row.index + 1;
        },
        enableColumnFilter: false,
        enableSorting: false,
      },
      // {
      //   header: "ID",
      //   accessorKey: "user_id",
      //   enableColumnFilter: false,
      //   enableSorting: false,
      // },
      {
        header: "Name",
        accessorKey: "user_name",
      },
      {
        header: "Email",
        accessorKey: "user_email",
      },
      {
        header: "Phone",
        accessorKey: "phone_number",
        cell: ({ row }) => {
          const phone = row.original.phone_number || "";
          const countryCode = row.original.country_code || "";
          const formattedCountryCode = countryCode.startsWith("+")
            ? countryCode
            : `+${countryCode}`;

          return countryCode ? `${formattedCountryCode} ${phone}` : phone;
        },
      },
      {
        header: "Status",
        accessorKey: "status",
      },
      {
        header: "Actions",
        accessorKey: "actions",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          const mentor = cellProps.row.original;
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-success"
                onClick={() => handleEdit(mentor)}
              >
                <i className="mdi mdi-pencil font-size-18" />
              </Link>

              {(mentor.status === "Pending" ||
                mentor.status === "Rejected") && (
                <>
                  <Link
                    to="#"
                    className="text-success mx-2"
                    onClick={() => handleApprove(mentor)}
                  >
                    <i className="mdi mdi-check-circle font-size-18" />
                  </Link>
                </>
              )}
              {mentor.status === "Pending" && (
                <Link
                  to="#"
                  className="text-danger"
                  onClick={() => handleReject(mentor)}
                >
                  <i className="mdi mdi-close-circle font-size-18" />
                </Link>
              )}

              {/* Whatsapp button */}
              <Link
                to="#"
                className="text-success"
                onClick={() => handleWhatsApp(mentor.phone_number)}
              >
                <i className="mdi mdi-whatsapp font-size-18" />
              </Link>
              {/*Delete Button */}
              <Link
                to="#"
                className="text-danger"
                onClick={() => handleDelete(mentor)}
              >
                <i className="mdi mdi-delete font-size-18" />
              </Link>
            </div>
          );
        },
      },
    ],
    [teams]
  );

  return (
    <React.Fragment>
      <TeamsModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(false)}
        mentor={selectedMentor}
        isEdit={!!selectedMentor}
        refreshData={fetchTeam}
      />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={confirmDelete}
        onCloseClick={() => setDeleteModal(false)}
        message="Are you sure you want to delete this mentor? This action cannot be undone."
      />
      <RejectModal
        show={rejectModal}
        onRejectClick={confirmReject}
        onCloseClick={() => setRejectModal(false)}
        onChange={(e) => setRejectReason(e.target.value)}
        reason={rejectReason}
        title="Reject Tutor"
        message="Are you sure you want to reject this tutor? This action cannot be undone."
        rejectButtonText="Reject Tutor"
        reasonPlaceholder="Please provide a reason for rejecting this tutor"
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            breadcrumbItem="Expert Team"
            breadcrumbItem2="Teams List"
          />
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={teams}
                    isGlobalFilter={false}
                    isAddButton={true}
                    customPageSize={10}
                    isPagination={true}
                    handleUserClick={handleAdd}
                    buttonClass="btn btn-success btn-rounded waves-effect waves-light mb-2 me-2"
                    buttonName=" Add Mentor"
                    tableClass="align-middle table-nowrap dt-responsive nowrap w-100"
                    theadClass="table-light"
                    pagination="pagination"
                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

export default TeamsList;
